import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddressInput } from '../../../../common/Form/AddressInput/AddressInput';
import { EditLabel } from '../../../../common/Form/EditLabel/EditLabel';
import { Input } from '../../../../common/Form/Input/Input';
import { PhoneNumberInput } from '../../../../common/Form/PhoneNumberInput/PhoneNumberInput';
import EditPersonalDetails from './EditPersonalDetails/EditPersonalDetails';
import styles from './PersonalDetails.module.scss';

function PersonalDetails(props) {
  const { userData, updateUserData, updating } = props;
  const { FirstName, LastName, SecondaryEmail, PrimaryEmail, Phone, PhoneCountryCode, PhoneType } = userData || [];

  const [editPersonalDetails, setEditPersonalDetails] = useState(false);
  const { t } = useTranslation();

  return (
    <form className={styles.profileDetails}>
      <EditLabel purpose={t('dashboard.profile.details.personal')} onClick={() => setEditPersonalDetails(true)} icon />
      <EditPersonalDetails
        data={userData}
        state={editPersonalDetails}
        changeState={setEditPersonalDetails}
        updateUserData={updateUserData}
        updating={updating}
      />
      <div className={styles.personalDetails}>
        <Input
          readOnly
          value={FirstName}
          placeholder={t('common.forms.firstname')}
          label={t('common.forms.firstname')}
          type="text"
        />
        <Input
          readOnly
          value={LastName}
          placeholder={t('common.forms.lastname')}
          label={t('common.forms.lastname')}
          type="text"
        />
        <Input
          readOnly
          defaultValue={PrimaryEmail}
          placeholder={t('common.forms.primaryplaceholder')}
          label={t('common.forms.primaryemail')}
          type="email"
        />
        <Input
          readOnly
          value={SecondaryEmail}
          placeholder={t('common.forms.secondaryplaceholder')}
          label={t('common.forms.secondaryemail')}
          type="email"
        />
        <PhoneNumberInput phone={`${PhoneCountryCode}${Phone}`.slice(1)} disabled />
        <Input
          readOnly
          value={PhoneType}
          placeholder={t('common.forms.mobile')}
          label={t('common.forms.phonetype')}
          type="text"
        />
      </div>
      <div className="mt-5">
        <AddressInput userData={userData} updateUserData={updateUserData} disabled />
      </div>
    </form>
  );
}

export default PersonalDetails;
